import React from 'react';
import PropTypes from 'prop-types';

import {DateRangeFilter} from '@utils/commonFilters/DateRangeFilter';

export const BookingsDatesFields = ({
    loading,
    clientFilters,
    dateConfigProps: {
        onChange,
        fromMaxDate,
        fromMaxDateDefault,
        fromMaxTime,
        toMinDate,
        toMinDateDefault,
        toMinTime,
        restoreFilterDateValues,
    },
}) => (
    <DateRangeFilter
        loading={loading}
        filters={clientFilters}
        restoreFilterDateValues={restoreFilterDateValues}
        onChange={onChange}
        dateConfig={{
            fromMaxDate,
            fromMaxDateDefault,
            fromMaxTime,
            toMinDate,
            toMinDateDefault,
            toMinTime,
        }}
    />
);

BookingsDatesFields.propTypes = {
    loading: PropTypes.bool,
    clientFilters: PropTypes.object.isRequired,
    dateConfigProps: PropTypes.shape({
        onChange: PropTypes.func,
        fromMaxDate: PropTypes.object,
        fromMaxDateDefault: PropTypes.object,
        fromMaxTime: PropTypes.object,
        toMinDate: PropTypes.object,
        toMinDateDefault: PropTypes.object,
        toMinTime: PropTypes.object,
        restoreFilterDateValues: PropTypes.func.isRequired,
    }).isRequired,
};
